import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './locales/i18n';
import { YMInitializer } from 'react-yandex-metrika';
import config from "./config"

ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback={null}>  {/* a fallback component, for example a loading indicator */}
            <App />
        </Suspense>
        {
            config.yandexMetrika ?
                <YMInitializer 
                    accounts={[config.yandexMetrika.account]}
                    options={config.yandexMetrika.options}
                />
            : null
            
        }
    </React.StrictMode >,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
